import React from 'react'

const TabEvents = () => {
  return (
    <div>TabEvents</div>
  )
}

export default TabEvents